import {
  MetaTouchpointSetup,
  TiktokTouchpointSetup,
  YouTubeTouchpointSetup,
} from '../interfaces';

const getSaturationNullish = (
  minMaxValues?:
    | MetaTouchpointSetup
    | TiktokTouchpointSetup
    | YouTubeTouchpointSetup
) => {
  return (
    minMaxValues?.saturationMin === null &&
    minMaxValues?.saturationMax === null &&
    minMaxValues?.saturationDefault === null
  );
};

export default getSaturationNullish;
